import { Plugin } from 'prosemirror-state';

import { AddMenuSpacer, Spacer } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.spacer.title') as string,
            description: t('Lygo:Menu.spacer.description') as string,
            icon: Spacer,
            addMenuIcon: AddMenuSpacer,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['spacer', 'basic'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
